import React from 'react';
import { withIcon, SvgIconProps } from '../../../../components/withIcon';

const SvgCaretDownOutlined = ({ size, title = 'CaretDownOutlined', ...props }: SvgIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width={size}
        height={size}
        data-icon-name={title}
        aria-label={title}
        role="presentation"
        {...props}
    >
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M5.75 9.5l6.25 6 6.25-6"
            />
        </g>
    </svg>
);

export default withIcon(SvgCaretDownOutlined);
